import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { ArrowUpRight } from "lucide-react";
import ParallaxImage from "@/components/motion/ParallaxImage";

export default function WorkCard({ item, index = 0, className = "" }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 50 }}
      whileInView={{ opacity: 1, y: 0 }}
      viewport={{ once: true, margin: "-8%" }}
      transition={{ duration: 0.8, ease: [0.76, 0, 0.24, 1], delay: (index % 2) * 0.08 }}
      className={className}
    >
      <Link
        to={`/work/${item.slug}`}
        data-testid={`work-card-${item.slug}`}
        data-cursor="view"
        className="group block"
      >
        <div className="relative aspect-[4/3] overflow-hidden bg-line">
          <ParallaxImage
            src={item.image}
            alt={`${item.client} — ${item.title}`}
            className="absolute inset-0"
            strength={6}
            imgClassName="transition-transform duration-700 ease-out group-hover:scale-[1.06]"
          />
          <div className="pointer-events-none absolute inset-0 bg-ink/0 transition-colors duration-500 group-hover:bg-ink/25" />
          <span className="absolute right-4 top-4 flex h-11 w-11 translate-y-2 items-center justify-center rounded-full bg-bone text-ink opacity-0 transition-all duration-500 group-hover:translate-y-0 group-hover:opacity-100">
            <ArrowUpRight size={20} />
          </span>
        </div>
        <div className="mt-4 flex items-start justify-between gap-4">
          <div>
            <h3 className="font-display text-2xl font-extrabold leading-tight text-ink transition-colors duration-300 group-hover:text-accent md:text-3xl">
              {item.client}
            </h3>
            <p className="mt-1 text-sm text-muted">{item.title}{item.year ? ` · ${item.year}` : ""}</p>
          </div>
          <span className="shrink-0 text-xs font-bold uppercase tracking-[0.14em] text-muted">{item.category}</span>
        </div>
      </Link>
    </motion.div>
  );
}
